import {EventName, isValidEventName} from '@web-landing/analytics/events';

const MARKER_ATTR = 'data-scroll-target';
const EVENT_NAME_ATTR = `${MARKER_ATTR}-event-name`;
const THRESHOLD_ATTR = `${MARKER_ATTR}-threshold`;
const DEPTH_ATTR = `${MARKER_ATTR}-depth`;
const DEFAULT_THRESHOLD = 1.0;

export type ScrollTargetConfig = {
  eventName: EventName;
  scrollDepth: string;
  threshold?: number;
};

export const findAllScrollTargets = () =>
  Array.from(document.querySelectorAll<HTMLDivElement>(`div[${MARKER_ATTR}]`));

export const extractScrollTargetAttributes = (
  element: HTMLDivElement,
): Required<ScrollTargetConfig> | null => {
  const {dataset} = element;
  const eventName = dataset.scrollTargetEventName;
  const scrollDepth = dataset.scrollTargetDepth;

  if (!eventName || !isValidEventName(eventName) || !scrollDepth) {
    return null;
  }

  let threshold = +(dataset.scrollTargetThreshold ?? DEFAULT_THRESHOLD);

  if (isNaN(threshold)) {
    threshold = DEFAULT_THRESHOLD;
  }

  return {eventName, scrollDepth, threshold};
};

export const buildScrollTargetAttributes = (config: ScrollTargetConfig) => ({
  [`${MARKER_ATTR}`]: 'true',
  [`${EVENT_NAME_ATTR}`]: config.eventName,
  [`${DEPTH_ATTR}`]: config.scrollDepth,
  ...(typeof config.threshold === 'number' && {
    [`${THRESHOLD_ATTR}`]: `${config.threshold}`,
  }),
});
